import { Button } from "./Button.js";

export interface ErrorStateProps {
  title?: string;
  body?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({ title = "Something went wrong", body, onRetry, retryLabel = "Try again" }: ErrorStateProps) {
  return (
    <div className="ui-state ui-state--error" role="alert">
      <span className="ui-state__icon" aria-hidden>⚠️</span>
      <p className="ui-state__title">{title}</p>
      {body && <p className="ui-state__body">{body}</p>}
      {onRetry && <Button variant="primary" onClick={onRetry} style={{ marginTop: 8 }}>{retryLabel}</Button>}
    </div>
  );
}
